


























import { defineComponent } from "vue-demi";

export default defineComponent({
  name: "MPServices",
  computed: {
    services() {
      return [
        {
          index: 0,
          name: "05RU",
          desc: "Магазин электроники",
          path: "https://05.ru/",
        },
        {
          index: 1,
          name: "Маркет",
          desc: "Ваша онлайн-витрина",
          path: "https://market.05.ru/",
        },
        {
          index: 2,
          name: "Близко",
          desc: "Доставка продуктов",
          path: "https://blizko.05.ru/",
        },
        {
          index: 3,
          name: "Рассрочка",
          desc: "по нормам Ислама",
          path: "https://05.ru/about/rassrochka/",
        },
      ];
    },
  },
});
